import { tzAxios } from 'api/axios';
import { apiAlipayAuthcodeRequest } from 'api/requestTypes';
import { apiQiTokenResponse } from 'api/responseTypes';

export const apiAlipayAuthcode = async (payload: apiAlipayAuthcodeRequest) =>
  (await tzAxios.post<apiQiTokenResponse>(`/users/mini-program-sign-up`, payload)).data;
